import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Site } from './../models/site_model';

@Injectable()
export class OpSitesService {


  constructor(private http: HttpClient) { }
  setHeader() {
    let headers = new HttpHeaders();
    return headers;
  }
  myHeaders = this.setHeader();

  getAllSite() {
    let url = environment.URL + "/site/getall";
    return this.http.get(url, { headers: this.myHeaders });
  }

  getAllSitesByGroup() {
    let url = environment.URL + "/siteGroup/getAllSitesByGroup";
    return this.http.get(url, { headers: this.myHeaders });
  }

  siteRecordById(siteId) {
    let url = environment.URL + "/site/edit/" + siteId;
    return this.http.get(url, { headers: this.myHeaders });
  }

  saveSite(bodyParams: Site) {
    let url = environment.URL + "/site/create";
    return this.http.post(url, bodyParams, { headers: this.myHeaders });
  }

  updateSite(bodyParams: Site) {
    let url = environment.URL + "/site/update";
    return this.http.post(url, bodyParams, { headers: this.myHeaders });
  }

  deleteSite(bodyParams: Site) {
    let url = environment.URL + "/site/delete/" + bodyParams.id;
    return this.http.get(url, { headers: this.myHeaders });
  }

  tableSearch(value, column, pageId) {
    let url = environment.URL + "/site/" + value + "/" + column + "?page=" + pageId;
    return this.http.get(url, { headers: this.myHeaders });
  }

  import(formData: FormData) {
    let url = environment.URL + "/site/import";
    return this.http.post(url, formData, { headers: this.myHeaders });
  }

  ordersListBySite(siteId) {
    let url = environment.URL + "/site/ordersListBySite/" + siteId;
    return this.http.get(url, { headers: this.myHeaders });
  }

  managersListBySite(siteId) {
    let url = environment.URL + "/site/managersListBySite/" + siteId;
    return this.http.get(url, { headers: this.myHeaders });
  }

  Commissionpayableto() {
    let url = environment.URL + "/code/commission_payable_to";
    return this.http.get(url, { headers: this.myHeaders });
  }

  JobStatus() {
    let url = environment.URL + "/code/job_status";
    return this.http.get(url, { headers: this.myHeaders });
  }

  updateSiteCommision(bodyParams) {
    let url = environment.URL + "/site/update/commission";
    return this.http.post(url, bodyParams, { headers: this.myHeaders });
  }

  updateSiteGroupCommision(bodyParams) {
    let url = environment.URL + "/siteGroup/update/commission";
    return this.http.post(url, bodyParams, { headers: this.myHeaders });
  }

}
